export function roundPoint(value: number): number {
    return Math.round(value * 10) / 10;
}

export function formatNumber(value: number): string {
    return Number(value).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}
